type OptionKeys = 'isUpperCase';
type NormalizeFuncType = (str: string, options?: Record<OptionKeys, boolean>) => string;

export const normalize: NormalizeFuncType = (str, options) => {
  if (!str) return '';

  const s = str.replaceAll('-', ' ');

  if (options?.isUpperCase) {
    return s.split(' ').reduce((acc, word) => {
      if (!word) return acc;

      const capitalized = word.charAt(0).toUpperCase() + word.slice(1);

      return acc ? `${acc} ${capitalized}` : capitalized;
    }, '');
  }

  return s.charAt(0).toUpperCase() + s.slice(1);
};
